import { useEffect, useState } from 'react';
import { React, Modal, Button } from '../utils/thirdpartyComponents';
import '../components/CWModal.scss';
import { AdminOrderHardwareApi } from '../utils/apiUrls';
import axios from '../config/axiosConfig';
import { MessageToaster } from '../utils/toastUtil';

interface Device {
  washBayDeviceID: number;
  deviceName: string;
  hardwareStatus: boolean;
  isSelected?: boolean
}

const AssignDeviceModal = (props: any) => {
  const { show, onHide, deviceType } = props;
  // Instantiate MessageToaster
  const toaster = new MessageToaster();

  const [availableDevices, setAvailableDevices] = useState<Device[]>([]);

  const [selectedDevices, setSelectedDevices] = useState<Device[]>([]);


  useEffect(() => {
    if (!show || deviceType === undefined || deviceType === null) {
      return;
    }
    setSelectedDevices([]);
    setAvailableDevices([]);
    getDeviceList(deviceType);
  }, [show, deviceType]);

  const handleOnHide = () => {
    onHide();
  };

  const toggleDeviceSelection = (deviceId: number, list: 'available' | 'selected') => {
    const updateList = list === 'available' ? availableDevices : selectedDevices;
    const setList = list === 'available' ? setAvailableDevices : setSelectedDevices;

    setList(
      updateList.map((device) =>
        device.washBayDeviceID === deviceId ? { ...device, isSelected: !device.isSelected } : device
      )
    );
  };

  const moveSelectedDevices = (source: 'available' | 'selected') => {
    if (source === 'available') {
      const devicesToMove = availableDevices?.filter((device) => device.isSelected);
      setAvailableDevices(availableDevices?.filter((device) => !device.isSelected));
      setSelectedDevices([...selectedDevices, ...devicesToMove.map((device) => ({ ...device, isSelected: false }))]);
    } else {
      const devicesToMove = selectedDevices.filter((device) => device.isSelected);
      setSelectedDevices(selectedDevices.filter((device) => !device.isSelected));
      setAvailableDevices([...availableDevices, ...devicesToMove.map((device) => ({ ...device, isSelected: false }))]);
    }
  };

  const getDeviceList = async (type: number | string) => {
    try {
      const { data } = await axios.get(AdminOrderHardwareApi.WASH_BAY_DEVICE_LIST, {
        params: { deviceType: type },
      });

      if (data?.error === 0) {
        setAvailableDevices(data?.data);

      }
      else {
        toaster.toastError(data?.message);
      }
    } catch (error: any) {
      throw new Error(error.response?.data?.message || error.message);
    } 
  }

  const assignDevices = async () => {
    try {
      handleOnHide()
      const selectedDevicesAssignment = selectedDevices.map(device => device.washBayDeviceID)

      if (selectedDevicesAssignment.length == props.quanity) {
        const assignRequest = {
          "carWashId": props?.carWashId,
          "purchaseDtlsId": props?.purchaseDtlsId,
          "deviceIds": selectedDevicesAssignment
        }
        const { data } = await axios.post(AdminOrderHardwareApi.ASSIGN_DEVICES, assignRequest);

        if (data?.error === 0) {
          toaster.toastSuccess(data?.message);
          props.onAssignSuccess()
        }
        else {
          toaster.toastError(data?.message);
        }
      }
      else if (selectedDevicesAssignment.length < props.quanity) {
        toaster.toastError(`You have selected fewer devices than required.Please select ${props.quanity} devices`);
      }
      else if (selectedDevicesAssignment.length > props.quanity) {
        toaster.toastError(`You have selected more devices than required. Please limit your selection to ${props.quanity} devices`);
      }


    } catch (error: any) {
      throw new Error(error.response?.data?.message || error.message);
    } 
  }

  return (
    <Modal show={show} onHide={handleOnHide} centered className='assign-modal'>
      <Modal.Body>
        <h5 className='f-bold'>Assign Devices</h5>
        <div className="assign-device-wrap d-flex">
          {/* Available Devices */}
          <div className="device-list-block">
            <div className="title d-flex align-items-center justify-content-between">
              <h2 className='fw-bold'>Available Devices</h2>
              <p><span className='fw-bold'>{availableDevices && availableDevices?.filter((device) => device.isSelected).length}</span> Items Selected</p>
            </div>
            {availableDevices && availableDevices?.map((device) => (
              <div className="device-card" key={device.washBayDeviceID}>
                <label className="check-wrap d-flex w-100 position-relative">
                  <input
                    type="checkbox"
                    className='input-check'
                    checked={device.isSelected}
                    onChange={() => toggleDeviceSelection(device.washBayDeviceID, 'available')}
                  />
                  <span className="card-info d-flex w-100 align-items-center">
                    <div className="text-info">
                      <p>Device Name: <span className='f-semi'>{device.deviceName}</span></p>
                    </div>
                  </span>
                </label>
              </div>
            ))}
          </div>

          {/* Move Buttons */}
          <div className="device-action d-flex flex-column">
            <Button
              variant="outline"
              className='outline-btn btn-move d-flex align-items-center justify-content-center'
              onClick={() => moveSelectedDevices('available')}
              disabled={availableDevices?.every((device) => !device.isSelected)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="11.966" height="17.35" viewBox="0 0 11.966 17.35">
                <path id="Polygon_1" d="M7.056,2.233a2,2,0,0,1,3.238,0l4.755,6.558a2,2,0,0,1-1.619,3.174H3.92A2,2,0,0,1,2.3,8.792Z" transform="translate(11.966) rotate(90)" fill="#989da9" />
              </svg>
            </Button>
            <Button
              variant="outline"
              className='outline-btn btn-move d-flex align-items-center justify-content-center'
              onClick={() => moveSelectedDevices('selected')}
              disabled={selectedDevices.every((device) => !device.isSelected)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="11.966" height="17.35" viewBox="0 0 11.966 17.35">
                <path id="Polygon_1" d="M7.056,2.233a2,2,0,0,1,3.238,0l4.755,6.558a2,2,0,0,1-1.619,3.174H3.92A2,2,0,0,1,2.3,8.792Z" transform="translate(0 17.35) rotate(-90)" fill="#989da9" />
              </svg>
            </Button>
          </div>

          {/* Selected Devices */}
          <div className="device-list-block">
            <div className="title d-flex align-items-center justify-content-between">
              <h2 className='fw-bold'>Selected Devices</h2>
            </div>
            {selectedDevices.map((device) => (
              <div className="device-card" key={device.washBayDeviceID}>
                <label className="check-wrap d-flex w-100 position-relative">
                  <input
                    type="checkbox"
                    className='input-check'
                    checked={device.isSelected}
                    onChange={() => toggleDeviceSelection(device.washBayDeviceID, 'selected')}
                  />
                  <span className="card-info d-flex w-100 align-items-center">
                    <div className="text-info">
                      <p>Device Name: <span className='f-semi'>{device.deviceName}</span></p>
                    </div>
                  </span>
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="btn-sec d-flex justify-content-end">
          <Button title="Cancel" variant="secondary" className='secondary-btn' onClick={handleOnHide}>Cancel</Button>
          <Button title="Save" variant="primary" className='primary-btn' onClick={assignDevices}>Save</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AssignDeviceModal;
